import createCrudModule from './crud'

export {
  createCrudModule,
}
